/**
 * Case Studies registry — mirror of `data/articles.js` for case studies.
 *
 * Contract per entry:
 *   slug          : URL segment under /case-studies/
 *   title         : full display title
 *   client        : short atelier / designer name
 *   location      : city, state
 *   discipline    : jewellery style tag (e.g. "Jadau bridal")
 *   published     : ISO date (YYYY-MM-DD)
 *   readMinutes   : approx read time
 *   tldr          : 1-2 sentence outcome summary (LLMs quote this)
 *   metrics       : optional [{label, value}] pairs shown as a hero strip
 *   featured      : boolean — floats to top of index
 *
 * Case studies live in `pages/caseStudies/<Slug>.jsx` and are code-split
 * from `pages/CaseStudy.jsx` (same lazy-load pattern as articles).
 */
export const CASE_STUDIES = [
  {
    slug: "jaipur-atelier-jadau-rani-haar",
    title: "How a Jaipur atelier cut a Jadau Rani Haar's sketch-to-CAD cycle from 7 days to 4 hours",
    client: "Sample Atelier · Jaipur",
    location: "Jaipur, Rajasthan",
    discipline: "Jadau bridal",
    published: "2026-02-14",
    readMinutes: 6,
    tldr: "A Jaipur bridal atelier reduced their Rani Haar sketch-to-CAD handoff from a 7-day back-and-forth to a same-day 4-hour workflow by running the design through Facetra's sketch-to-render, multi-view sheet and CAD-ready modes before sending it to the karigar. Result: 3× more designs approved per week, zero handoff ambiguity, faster bridal season revenue.",
    metrics: [
      { label: "Sketch → CAD time", value: "7 days → 4 hrs" },
      { label: "Designs approved / wk", value: "3× more" },
      { label: "Karigar revisions", value: "−80%" },
    ],
    featured: true,
  },
];

export function getCaseStudy(slug) {
  const clean = String(slug || "").toLowerCase();
  return CASE_STUDIES.find((c) => c.slug === clean) || null;
}

export function getRelatedCaseStudies(slug, count = 3) {
  return CASE_STUDIES.filter((c) => c.slug !== slug).slice(0, count);
}
